import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit, inject, input } from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {Subject} from "rxjs";
import {filter, takeUntil} from "rxjs/operators";
import {isUrlInChildren} from "../../../../utilities/route";
import {slideInOut} from "../../../../utilities/animation";

import type NavigationMenu from "../../navigation.model";


@Component({
    selector: 'app-navigation-collapsable',
    templateUrl: './collapsable.component.html',
    styleUrls: ['./collapsable.component.scss', '../menu-item.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [slideInOut],
    standalone: false
})
export class CollapsableComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);


  readonly item = input<NavigationMenu>(undefined);

  @HostBinding('class.active') opened = false;

  private unsubscribeAll = new Subject<void>();

  ngOnInit(): void {
    this.opened = isUrlInChildren(this.item(), this.router.url);
    this.router.events.pipe(filter(event => event instanceof NavigationEnd), takeUntil(this.unsubscribeAll))
      .subscribe((event: NavigationEnd) => {
        this.opened = isUrlInChildren(this.item(), event.urlAfterRedirects);
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  toggle() {
    this.opened = !this.opened
  }

}
